import createComponent from "@/utils/create-component"
import ErrorPage from "@/pages/error-page/components/error-page.vue"

export default function createBookPage() {
  createComponent({
    el: "#vue-error-page",
    component: ErrorPage
  })
}
